import { render, staticRenderFns } from "./BTreeItem.vue?vue&type=template&id=2b9b954c"
import script from "./BTreeItem.vue?vue&type=script&lang=js"
export * from "./BTreeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports